import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InventoryListItem } from './type';

export interface ItemListItemRemovedEvent {
  itemId: string;
  parentItemId?: string;
  isNested: boolean;
}

@Component({
  selector: 'inventory-ui-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss'],
  standalone: false,
})
export class ItemListComponent {
  @Input() items: InventoryListItem[] = [];
  @Input() removeButtonEnabled = false;
  @Input() showStatus = false;

  @Output() itemRemoved = new EventEmitter<ItemListItemRemovedEvent>();

  removeItem(itemId: string, parentItemId: string, isNested: boolean): void {
    this.itemRemoved.emit({ itemId, parentItemId, isNested });
  }
}
